let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aryd9")).then(() => parcelRequire('g0MkC'));